import { Component } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
export default class Modal extends Component {
    constructor(props = {}) {
        super(props);
        const { containerId, divclass = null, style } = props;
        this.modalRoot = document.getElementById(containerId);
        this.element = document.createElement('div');
        if (divclass) {
            this.element.classList.add(divclass);
        }
        if (style) {
            Object.keys(style).forEach(key => {
                this.element.style[key] = style[key];
            });
        }
    }
    componentDidMount() {
        this.modalRoot?.appendChild(this.element);
    }
    componentWillUnmount() {
        this.modalRoot?.removeChild(this.element);
    }
    render() {
        return createPortal(this.props.children, this.element);
    }
}

Modal.propTypes = {
    containerId: PropTypes.string,
    divclass: PropTypes.string,
    children: PropTypes.node,
};
